import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import RelayTab1 from './RelayTab1/RelayTab1';
import PvParameterTabContent from '../../pv_monitoring/pv_monitoring_tabs/pv_parameter/pv_parameter_tabs/PvParameterTabContent';



export default function RelayTabs({ TabTitle, ID }) {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));


    const [key, setKey] = useState('Chart');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>

            <Box mt={spacing(1)}>
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >

                    <Tab eventKey="Chart" title="Chart">
                        <RelayTab1 TabTitle={TabTitle} ID={ID} />
                    </Tab>



                    {/* <Tab eventKey="Log" title="Log">
                    
                    <PvParameterTabContent TabTitle={TabTitle} ID={ID} />
                    </Tab> */}
                    <Tab
                        eventKey="Log"
                        title="Log"
                        mountOnEnter
                        unmountOnExit={false}
                    >
                        <PvParameterTabContent TabTitle={TabTitle} ID={ID} />
                    </Tab>

                </Tabs>
            </Box>
        </Box>

    )
}